import { apiJson, apiRequest } from "../../../shared/lib/api-client.ts";
import type { ApiResponse } from "../../leaderboard/types/index.ts";
import type { AuditLogData, AuditLogProviderResult, TgeScanRunResult } from "../types/index.ts";

export async function getAuditLogs(params: {
  limit?: number;
  offset?: number;
  actionType?: string;
  triggerSource?: string;
  status?: string;
  search?: string;
}): Promise<AuditLogData> {
  const query = new URLSearchParams();
  if (params.limit) query.set("limit", String(params.limit));
  if (params.offset) query.set("offset", String(params.offset));
  if (params.actionType && params.actionType !== "all") query.set("action_type", params.actionType);
  if (params.triggerSource && params.triggerSource !== "all")
    query.set("trigger_source", params.triggerSource);
  if (params.status && params.status !== "all") query.set("status", params.status);
  if (params.search) query.set("search", params.search);

  const qs = query.toString();
  const payload = await apiJson<ApiResponse<AuditLogData>>(
    `/v1/admin/audit-logs${qs ? `?${qs}` : ""}`
  );
  return payload.data ?? { entries: [], total: 0 };
}

export async function getAuditRunProviders(
  projectId: string,
  auditRunId: string
): Promise<AuditLogProviderResult[]> {
  try {
    const res = await apiRequest(`/v1/projects/${projectId}/audits/${auditRunId}/evidence`);
    if (!res.ok) return [];
    const payload = (await res.json()) as ApiResponse<
      Array<{
        provider_slug: string;
        sub_score: number | null;
        error_message: string | null;
        duration_ms: number | null;
      }>
    >;
    return (payload.data ?? []).map((e) => ({
      providerSlug: e.provider_slug,
      success: e.error_message == null && e.sub_score != null,
      subScore: e.sub_score != null ? Number(e.sub_score) : null,
      errorMessage: e.error_message,
      durationMs: e.duration_ms != null ? Number(e.duration_ms) : null,
    }));
  } catch {
    return [];
  }
}

export async function getTgeScanRunResults(runId: number): Promise<TgeScanRunResult[]> {
  try {
    const payload = await apiJson<ApiResponse<TgeScanRunResult[]>>(
      `/v1/admin/tge-scan-runs/${runId}/results`
    );
    return payload.data ?? [];
  } catch {
    return [];
  }
}
